import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http'
import 'rxjs/add/operator/map';
import {Observable} from "rxjs";
import {AppSettings} from "../../app/app.settings";

@Injectable()
export class ApiServiceProvider {

  private API_ENDPOINT = AppSettings.API_ENDPOINT;

  private headers: HttpHeaders;

  constructor(public http: HttpClient) {
    this.headers = new HttpHeaders();
    this.headers.append('content-type',
      'application/json; charset=utf-8');
  }

  public get(apiPath) {
    return this.http.get(this.API_ENDPOINT + apiPath, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing GET for route ' + apiPath);
    // });
  }

  public post(apiPath, data) {
    let path = '';
    if (apiPath.indexOf('http') >= 0) {
      path = apiPath;
    } else {
      path = this.API_ENDPOINT + apiPath;
    }
    return this.http.post(path, data, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing POST for route ' + apiPath);
    // });
  }

  public put(apiPath, data) {
    return this.http.put(this.API_ENDPOINT + apiPath, data, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing PUT for route ' + apiPath);
    // });
  }

  public putFile(apiPath, data) {
    this.removeHeader("content-type")
    return this.http.put(this.API_ENDPOINT + apiPath, data, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing PUT for route ' + apiPath);
    // });
  }

  public patch(apiPath, data) {
    return this.http.patch(this.API_ENDPOINT + apiPath, data, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing PATCH for route ' + apiPath);
    // });
  }

  public delete(apiPath) {
    return this.http.delete(this.API_ENDPOINT + apiPath, {headers: this.headers})
      .map(this.extractData)
    // .catch(error => {
    //   return this.handleError(error || 'Error while executing DELETE for route ' + apiPath);
    // });
  }

  public setToken(token) {
    this.unsetToken();
    this.addHeader('Authorization', 'Bearer ' + token);
  }

  public unsetToken() {
    this.removeHeader('Authorization');
  }

  public addHeader(key, value) {
    this.headers.append(key, value);
  }

  public removeHeader(key) {
    this.headers.delete(key);
  }

  private handleError(error: any) {
    let data;
    try {
      data = JSON.parse(error.error);
    } catch (e) {
      data = error.error;
    }
    return Observable.throw({status: error.status, data});
  }

  private extractData(res: any) {
    return res;
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-service/api-service.ts